/**
 * Sports Banners
 *
 * @module app/components/banners/SportsBanners
 */
import jQuery from 'jquery';

/**
 * Show terms
 *
 * @returns {void}
 *
 * @private
 */
var showTerms = function () {

    jQuery('#main').find('.banner').removeClass('terms-hidden');
};

/**
 * Hide terms
 *
 * @returns {void}
 *
 * @private
 */
var hideTerms = function () {

    jQuery('#main').find('.banner').addClass('terms-hidden');
};

/**
 * Methods to be public
 *
 * @type {Object}
 */
var api = {

    init: function () {

        jQuery('#main').find('.toggle-terms .icon-info').on('click', showTerms);
        jQuery('#main').find('.toggle-terms .icon-x').on('click', hideTerms);
    },
};

export default api;
